import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getLiquiditätsbilanzList = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/liquidity/get?clientId=${clientId}`) : await axios.get(`/customer/liquidity/get`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
};

export const getLiquiditätsbilanz2List = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/liquidity/liquidity2?clientId=${clientId}`) : await axios.get(`/customer/liquidity/liquidity2`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}